import { dashboardByIdSelector } from "./dashboardByIdSelector";
import { RootState } from "@/store/store";
import { GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse } from "@/services/cloudchipr.api";

export const dashboardByIdDataSelector = (
  state: RootState,
  dashboardId: string,
): GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse | null => {
  return dashboardByIdSelector(state, dashboardId)?.data ?? null;
};
